import { z } from "zod/v4";

export const OnboardingInfoDtoSchema = z.object({
  id: z.string(),
  userReportedOrderCount: z.string(),
  teamDescription: z.string(),
  storeType: z.string(),
  productionStoreUrl: z.string().nullish(),
  agencyPrimaryOperator: z.string().nullish(),
  goals: z.string(),
});
export type OnboardingInfoDto = z.infer<typeof OnboardingInfoDtoSchema>;

export const GetOnboardingInfoSchema = OnboardingInfoDtoSchema.nullable();
export type GetOnboardingInfoType = z.infer<typeof GetOnboardingInfoSchema>;

export const CreateOnboardingInfoDtoSchema = OnboardingInfoDtoSchema.extend({
  id: z.string().optional(),
  buyingIntention: z.string().nullish(),
  sourceAttribution: z.string().nullish(),
});

export type CreateOnboardingInfoDto = z.infer<
  typeof CreateOnboardingInfoDtoSchema
>;
